<div class="wrapper">
    <div class="headerwrapper">
        <div class="headerbody noselect clicable" (click)="sendLastStep(0)" matRipple>
            <mat-icon class="fer-active" *ngIf="step === 0">radio_button_checked</mat-icon>
            <mat-icon class="fer-active" *ngIf="step === 1 || step === 2">check_circle</mat-icon>
            <span multilang>Personendaten</span>
        </div>
        <div class="lignesep" [class.fer-border-active]="step === 1 || step === 2"></div>
        <div class="headerbody noselect clicable" (click)="sendLastStep(1)" matRipple>
            <mat-icon class="fer-deactive" *ngIf="step === 0">circle</mat-icon>
            <mat-icon class="fer-active" *ngIf="step === 1">radio_button_checked</mat-icon>
            <mat-icon class="fer-active" *ngIf="step === 2">check_circle</mat-icon>
            <span multilang [class.fer-deactive]="step === 0">Übersicht</span>
        </div>
        <div class="lignesep" [class.fer-border-active]="step === 2"></div>
        <div class="headerbody">
            <ng-container *ngIf="step === 2; else other">
                <mat-icon class="fer-active">radio_button_checked</mat-icon>
            </ng-container>
            <span multilang [class.fer-deactive]="step !== 2">Übermitteln</span>
        </div>
    </div>
</div>

<ng-template #other>
    <mat-icon class="fer-deactive">circle</mat-icon>
</ng-template>